import Vue from 'vue'
import { getPlatforms, jsonEncode } from '~/utils'
import { getOptions } from '../utils/report'
let caches = []

const getEnvironment = () => {
  return getPlatforms()
}
const global = typeof window === 'object' ? window : {}

global.getDoctorTokenCallback = res => {
  // setLocal('token', res);
  window.localStorage.setItem('token', res)
  for (let i = 0; i < caches.length; i++) {
    typeof caches[i] == 'function' && caches[i]()
  }
  caches = []
}
//首页商品刷新
global.onStart = () => {
  const onStartEvent = new Event('onStart')
  window.dispatchEvent(onStartEvent)
}
global.clickExchangeRecord = () => {
  const clickExchangeRecord = new Event('clickExchangeRecord')
  window.dispatchEvent(clickExchangeRecord)
}
//触发
global.reloadTaskHallData = () => {
  const reloadTaskHallDataEvent = new Event('reloadTaskHallData')
  window.dispatchEvent(reloadTaskHallDataEvent)
}

// 视频二期预热：原生app通知是否满足报名条件
global.isPerfectInformation = result => {
  const isPerfectInformationEvent = new CustomEvent('isPerfectInformation', {
    detail: JSON.parse(result)
  })
  window.dispatchEvent(isPerfectInformationEvent)
}
// 视频二期预热报名获取医生id
global.getDoctorIdCallback = id => {
  console.log('医生Id:', id)
  window.localStorage.setItem('doctorId', id)
  if (typeof window === 'object') {
    window.$nuxt.$store.commit('getLocalStorageDoctorId', id)
  }
  for (let i = 0; i < caches.length; i++) {
    typeof caches[i] == 'function' && caches[i]()
  }
  caches = []
}

global.checkAppVersion = res => {
  window.localStorage.setItem('isNewVersion', res)
  if (typeof window === 'object') {
    const version = res ? res + '$' + new Date().getTime() : '1'
    window.$nuxt.$store.commit('updateAppVersion', version)
  }

  for (let i = 0; i < caches.length; i++) {
    typeof caches[i] == 'function' && caches[i]()
  }
  caches = []
}

const generateFunc = (func, params) => {
  params = params || ''
  if (getEnvironment().isiOS && window.webkit) {
    try {
      return window.webkit.messageHandlers[func].postMessage(params)
    } catch (e) {
      for (let i = 0; i < caches.length; i++) {
        typeof caches[i] == 'function' && caches[i]()
      }
      caches = []
    }
    return false
  }
  if (getEnvironment().isAndroid && window.webViewObj) {
    return window.webViewObj[func](params)
  }
  for (let i = 0; i < caches.length; i++) {
    typeof caches[i] == 'function' && caches[i]()
  }
  caches = []
}

Vue.prototype.$bridge = {
  goback() {
    return generateFunc('navigateBack')
  },
  getAppVersion: (callback = function() {}) => {
    caches.push(callback)
    return generateFunc('getAppVersion')
  },
  getToken: (callback = function() {}) => {
    caches.push(callback)
    return generateFunc('getDoctorToken')
  },
  didReceiveProfit() {
    return generateFunc('didReceiveAllPartnerProfit')
  },
  goPatient() {
    this.getHtmlEventTrakingPath()
    return generateFunc('pushToPatientList')
  },
  gobackIndex() {
    console.log('call the navigateBackIndex')
    return generateFunc('navigateBackIndex')
  },
  share() {
    console.log('call the share')
    return generateFunc('sharePage')
  },
  resolvePage() {
    return generateFunc('resolvePage')
  },
  pushToPersonInfo() {
    this.getHtmlEventTrakingPath()
    return generateFunc('pushToPersonInfo')
  },
  completeNewUserTask(params) {
    this.getHtmlEventTrakingPath()
    return generateFunc('completeNewUserTask', params)
  },
  pushToMall() {
    this.getHtmlEventTrakingPath()
    return generateFunc('pushToMall')
  },
  pushToActivity(params) {
    return generateFunc('pushToActivity', params)
  },
  pushToBindWechat(params) {
    return generateFunc('pushToBindWechat', params)
  },
  pushToBindAli(params) {
    return generateFunc('pushToBindAli', params)
  },
  // 分享微信
  shareByWechat(params) {
    return generateFunc('shareByWechat', params)
  },
  // 分享朋友圈
  shareByWechatCircle(params) {
    return generateFunc('shareByWechatCircle', params)
  },
  // 弹出分享弹窗
  shareArticle(params) {
    return generateFunc('shareArticle', params)
  },
  pushDoctorAttestation(params) {
    return generateFunc('pushDoctorAttestation', params)
  },
  login() {
    const self = this
    return new Promise(resolve => {
      let token = self.getToken()
      if (!token || typeof token === 'object') {
        return setTimeout(() => {
          resolve(true)
        }, 500)
      }
      window.localStorage.setItem('token', token)
      resolve(true)
    })
  },
  // 使用原生app navbar后给app传参
  useAppNativeNavbar(params) {
    return generateFunc('getNavigationBarAction', params)
  },
  // 视频二期预热：调用原生app的方法判断是否完善个人资料
  verifyInformation() {
    return generateFunc('verifyInformation')
  },
  // 视频二期预热获取医生id
  getDoctorId: (callback = function() {}) => {
    caches.push(callback)
    return generateFunc('getDoctorId')
  },
  // 原生弹窗交互
  nativeConfirm(params) {
    global.nativeConfirmButtonCb = params.confirmButtonCb || (() => {})
    delete params.confirmButtonCb
    return generateFunc('nativeConfirm', jsonEncode(params))
  },
  // 跳原生证件照上传页面
  goAppUploadCertificatePage() {
    this.getHtmlEventTrakingPath()
    return generateFunc('goAppUploadCertificatePage')
  },
  // 打电话
  callPhone(phoneNumber) {
    return generateFunc('phoneCall', phoneNumber)
  },
  // 跳原生订单详情页面
  goAppOrderDetailPage(prescriptionId) {
    this.getHtmlEventTrakingPath()
    return generateFunc('goAppOrderDetailPage', prescriptionId)
  },
  // 通知App做提现校验
  noticeAppCashCheck(params) {
    global.noticeAppCashCheckCb = params.noticeAppCashCheckCb || (() => {})
    delete params.noticeAppCashCheckCb
    return generateFunc('noticeAppCashCheck')
  },
  // 传递lastClick 名字
  onClickEvent(params) {
    return generateFunc('onClickEvent', params)
  },
  getHtmlEventTrakingPath() {
    const { pids = '' } = getOptions() || {}
    return generateFunc('getHtmlEventTrakingPath', pids)
  },

  // 认证资料-上传图片
  uploadImage(params) {
    return generateFunc('uploadImage', params)
  },

  // 第一次认证-提交资料
  onPostCertData(params) {
    return generateFunc('onPostCertData', params)
  },

  // 修改认证-提交资料
  onUpdateCertData(params) {
    return generateFunc('onUpdateCertData', params)
  },
  // 获取分享开方协议状态
  getSecrecySign(params) {
    return generateFunc('signPrescriptionManagementRegulations', params)
  },
  pushAction(params) {
    return generateFunc('pushAction', params)
  },
  //取消个人信息保护及隐私政策授权
  cancelAuth() {
    return generateFunc('cancelPrivacyPolicy')
  },
  // 防疫方
  getProphylacticPrescription(params) {
    return generateFunc('getProphylacticPrescription', params)
  },
  buildProphylacticPrescription() {
    return generateFunc('buildProphylacticPrescription')
  }
}

// 认证资料-上传图片返回的图片地址(上传图片成功)
global.uploadImageCallBack = res => {
  let type = '' // 图片类型
  let imgUrl = [] // 图片地址
  let obj = ''
  // 安卓和苹果返回的urls数据类型和res数据类型不同；苹果返回的res是json字符串，安卓返回的res是json对象
  if (res && typeof res === 'string') {
    obj = JSON.parse(res)
  }
  let objA = {
    '1': 'DoctorPracticing',
    '2': 'DoctorIdCard',
    '3': 'DoctorQualification',
    '4': 'ProfessionalQualification',
    '5': 'idcard_face',
    '6': 'idcard_emblem'
  }

  if (obj) {
    type = objA[obj.type]
    if (obj.urls && obj.urls instanceof Array && obj.urls.length > 0) {
      imgUrl = obj.urls
    } else if (obj.urls && typeof obj.urls === 'string') {
      imgUrl = [obj.urls]
    } else {
      imgUrl = []
    }
  }
  if (objA[obj.type] === 'DoctorPracticing') {
    window.$nuxt.$store.commit('userInfo/setDoctorPracticingPic', imgUrl)
  } else if (objA[obj.type] === 'DoctorIdCard') {
    window.$nuxt.$store.commit('userInfo/setIdCardPic', imgUrl)
  } else if (objA[obj.type] === 'DoctorQualification') {
    window.$nuxt.$store.commit('userInfo/setDoctorQualificationPic', imgUrl)
  } else if (objA[obj.type] === 'ProfessionalQualification') {
    window.$nuxt.$store.commit(
      'userInfo/setProfessionalQualificationPic',
      imgUrl
    )
  } else if (objA[obj.type] === 'idcard_face') {
    window.$nuxt.$store.commit('integration/setIdcardFace', imgUrl)
  } else if (objA[obj.type] === 'idcard_emblem') {
    window.$nuxt.$store.commit('integration/setIdcardEmblem', imgUrl)
  }
  // vuex的认证图片更新完毕后，通知前端更新本页面的认证图片更新
  window.$nuxt.$store.commit('userInfo/setAppUploadedImg', {
    type: type,
    urls: imgUrl
  })
}

// 认证资料-没有选图片直接返回或者上传图片失败
global.uploadImageCancel = () => {
  // vuex的认证图片更新完毕后，通知前端更新本页面的认证图片更新
  window.$nuxt.$store.commit('userInfo/setAppUploadedImg', {
    type: window.$nuxt.$store.state.userInfo.type,
    urls: []
  })
}
